// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    border-radius: 0px !important;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12 {
    float: left;
}

.tblPermitTemplate {
    width: 98.6%;
}

.cs-body-pdf {
    margin: 0;
    padding: 0;
    position: absolute;
    background-image: linear-gradient(0deg, rgba(255, 255, 255, .35), rgba(255, 255, 255, 0));
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: -1;
    width: 100%;
    height: 7%;
}

input[type=url][_ngcontent-thv-c176],
input[type=search][_ngcontent-thv-c176],
input[type=text][_ngcontent-thv-c176],
input[type=datetime][_ngcontent-thv-c176],
input[type=date][_ngcontent-thv-c176],
textarea[_ngcontent-thv-c176] {
    font-size: 14px !important;
}

.cs-header {
    clear: both;
    width: 100%;
    margin: 0px auto;
}

.top-left {
    position: absolute;
    top: 40px;
    left: 40px;
    /* z-index: 999; */
}

.header-details {
    margin: 0px;
    padding: 5px 0px;
    /* color: #000000; */
}

.header-details h1,
.header-details h5,
.header-details p {
    margin: 0;
    padding: 0;
}

.header-details h1 {
    margin: 0px;
    padding: 10px 15px 10px 0px;
    text-align: center;
    /* font-size: 1.8em; */
    font-weight: 400;
    /* color: #fff; */
}

.header-details h5 {
    margin: 0px;
    padding: 5px 15px 10px 0px;
    text-align: center;
    font-size: 1em;
    font-weight: 400;
    /* color: #fff; */
}

.status-overlay-pdf {
    position: absolute;
    right: 46px;
    top: 28px;
    width: 128px;
    height: 33px;
    padding-top: 7px;
    cursor: pointer;
    background-color: #33aaff;
    color: #FFF !important;
    background-position: -496px -229px;
    padding-left: 13px;
    letter-spacing: 0.5px;
    font-size: 14px;
    /* position: absolute;
    right: 20px;
    top: 20px;
    width: 170px;
    height: 45px;
    margin-left: 12px;
    padding-top: 2px;
    cursor: pointer;
    background-color: #33aaff;
    color: #FFF !important;
    background-position: -496px -229px;
    padding-left: 7px;
    letter-spacing: 0.5px;
    font-size: 16px; */
}

tr:nth-child(even) {
    background-color: whitesmoke;
}

tr:nth-child(odd) {
    background-color: white;
}

#qusDiv:nth-child(even) {
    background-color: whitesmoke;
}

#qusDiv:nth-child(odd) {
    background-color: white;
}

#tblTypeBody:nth-child(even) {
    background-color: whitesmoke;
}

#tblTypeBody:nth-child(odd) {
    background-color: rgb(250, 250, 250);
}

.top-right {
    position: absolute;
    top: 20px;
    right: 25px;
    font-size: 25px;
    cursor: pointer;
}

.watermark {

    margin-top: auto;
    margin-bottom: auto;
    margin-right: auto;
    margin-left: 30%;
    position: absolute;
    z-index: 999;
    top: 0;
    bottom: 0;
    text-align: center;
    /* margin: auto; */
    left: 0;
    right: 0;
    width: 150px;
    height: 150px;
    font-weight: bold;
    font-size: 400%;
    color: #504e4e;
    opacity: 0.2;
    transform: rotate(-6deg) scale(1.7, 1.5);
}

.clsLogo {
    height: 51px;
    width: 180px;
    /* border: 1px solid #1F4E78; */
    padding-right: 5px;
    margin-top: 7px;
}

.mapImage {
    height: 800px !important;
    width: 100% !important;
}

.clsLogoHidden {
    height: 45px;
    width: 157px;
    padding-right: 5px;
    padding-top: 10px;
    padding-bottom: -5px;
}

:host ::ng-deep .ui-inputtext {
    /* width: 250px !important; */
    margin: 0;
    outline: medium none;
    padding: .25em;
    font-weight: normal;
}

:host ::ng-deep input[type=text] {
    border-radius: 0px !important;
}

.clsHeader {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    margin-left: -20px;
}

.clsHeaderWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
    /* margin-left: -6px; */
}

:host ::ng-deep input[disabled] {
    color: #848484 !important;
    background-color: white !important;
}

disabled {

    color: #848484 !important;
    background-color: white !important;

}

.clsHeaderHiddenChild {
    background-color: White;
    width: 30px;
    height: 100%;
    position: absolute;
    left: 10px;
}

/* .clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    margin-left: -20px;
} */


/* .clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 40px;
    padding: 10px;
    font-weight: bold;
   
} */
.clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    /* padding: 10px; */
    font-weight: bold;
    width: 100%;
    text-align: center;
}

.clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    /* padding: 10px; */
    font-weight: bold;
    width: 100%;
    text-align: center;
    /* margin-left: -6px; */
}

.left {

    display: table-cell;
    /* width:6%; */

}

.middle {

    display: table-cell;
    width: 100%;
}

.right {

    display: table-cell;
    width: 10%;

}



/* .clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
    /* margin-left: -6px; 
} */

/* .tblPermitTemplate td {
    background-color: white;
} */

/* .tblPermitTemplate tr {
    border: 1px solid #1F4E78;
} */

.tblPermitTemplate tr th {
    /* background-color: #1F4E78; */
    color: white;
}

/* ,td .tblPermitTemplate tr th  */
.tblPermitTemplate tr {
    padding: 6px;
}

.clsValue {
    color: black;
    /* font-weight: bold; */
    margin-left: 5px;
}

.clsTextArea {
    color: black;
    border: 1px solid #1F4E78;
    resize: none;
}

.clsTable {
    margin: 5px 5px 0px 0px;
    /* width: 100%; */
}

.clsTable td {
    /* border: 3px solid white !important; */
    border: 1px solid lightgray !important;
}

.clsTable th {
    border: 1px solid black;
}

.clsTablesContainer {
    overflow: auto;
    /* height: 425px; */
    margin-bottom: 5px;
}

.clsBgWhite {
    background-color: white;
    /* margin-bottom: 10px; */
}

.clsHeaderParent {
    width: 98.5%;
    padding-left: 30px;
    background-color: White;
}

#pnlPreviewTemp {
    /* background-color: white; */
    position: relative;
    padding-left: 30px;
    /* padding-right: 30px; */
    font-size: 30px !important;
}

/* .clsMarginBottom {
    margin-top: 15px !important;
    line-height: 30px;
    border-collapse: separate;
    border-spacing: 0 2em; 
}*/

.clsCheckboxContainer {
    padding: 5px;
    color: black;
    /* font-size: 30px; */
}

.clsCheckBox {
    height: 80px;
    overflow: auto;
}

.clsCheckboxDownContainer {
    padding: 5px;
    color: black;
    font-size: 30px;
    word-break: break-all;
}

.btn-primary {
    margin-right: 5px !important;
}

:host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788 !important;
    border-radius: 3px;
    background: #f4f4f4 !important;
    box-shadow: 3px 3px 12px #165788;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;
    /* margin-top: 10px; */
}

.toast-header {
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;
}

.approveMessage {
    color: #ff3232;
    font-weight: normal;
}

/* .permitTypeImages {
    height: 68px;
    width: 88%;
} */

.permitTypeImages {
    /* max-height: 88px;
    height: 100%;
     width: 100%;
     min-width: 88px; */
    width: 70px;
    height: 71px;
}

.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

:host ::ng-deep .p-dialog-mask {
    z-index: auto !important;
    position: relative;
}

:host ::ng-deep .ui-chkbox-label {
    font-size: 30px !important;
}

:host ::ng-deep .ui-radiobutton-label {
    font-size: 30px !important;
}

.clsShift {
    left: -3px !important;
}

::ng-deep label {    
    /* Add your custom css property value. */    
    
   
    font-weight: normal;
    margin-top: 5px;
 }

.vrtAlignLbl {
    /* padding: 0px 0px 0px 0px;
    font: 13px !important;
    top: 5px! important;
    position: relative; */
    padding-left: 15px !important;
}

.indentTable {
    position: relative;
    left: 15px !important;
    padding-right: 10px;
}

.row-align {
    padding: 5px 5px 5px 5px !important;
}

/* :host ::ng-deep body .ui-chkbox .ui-chkbox-box .ui-chkbox-icon {
    font-size: 20px !important;
  } */
:host ::ng-deep .ui-chkbox .ui-chkbox-box {
    border: 1px solid #000000 !important;
}

:host ::ng-deep .ui-radiobutton .ui-radiobutton-box {
    border: 1px solid #000000 !important;
}

:host ::ng-deep body .ui-radiobutton-label {
    font-size: 30px !important;
}

:host ::ng-deep body .ui-chkbox-label {
    font-size: 30px !important;
}

span {
    color: #000000 !important;
}

.clsTablesContainer td {
    border-color: Gray !important;
}

input[type=url],
input[type=search],
input[type=text],
input[type=datetime],
input[type=date],
textarea {
    font-size: 30px !important;
}

.text-style {
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.clsInnerHtml,
.clsInnerHtml *,
.clsInnerHtml p,
.clsInnerHtml span {
    display: block !important;
    white-space: normal !important;
    overflow-wrap: break-word !important;
    word-break: normal !important;
    max-width: 100%;
    width: 96% !important;
}

/* Text element width class for textbox, textarea, label, paragraph content */
.clsTextElementWidth {
    width: 98% !important;
    padding-left: 15px;
}

.blank-height {
    min-height: 35px !important;
    display: inline-block !important;
}

.list-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    background-color: #eeee e;
    padding: 5px;
    color: black;
}

/* .clsBorder{
    border: 1px solid lightgrey !important;
} */

/* :host ::ng-deep .clsInnerHtml > p > span{
    margin-left: 8px !important;
    float: left !important;
} */

.left-margin {
    /* padding: 15px 0px 0px 10px !important; */
    padding: 0px 0px 0px 10px !important;
    /* padding: 5px 10px !important; */
}
.left-margin-para {
    /* padding: 15px 0px 0px 10px !important; */
    padding: 0px 0px 0px 20px !important;
    /* padding: 5px 10px !important; */
}

.paragraph-margin {
    padding: 0px 0px 7px 0px !important;
}

.upload-margin {
    padding-top: 10px !important;
}

/* table { page-break-inside:auto }
div   { page-break-inside:avoid; } 
thead { display:table-header-group }
tfoot { display:table-footer-group } */

.asset-div {
    background-color: #f2faff !important;
    border: 1px solid #ede9d8;
}

.wo-div {
    background-color: #ffffff !important;
    border: 1px solid #ede9d8;
    margin: 10px;
    padding: 5px;
}

/* border: 1px solid #ede9d8; */
.op-div {
    background-color: #ffffff !important;
    margin: 5px;
    padding: 3px;
}

@font-face {
    font-family: "DejaVu Sans";
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans.ttf") format("truetype");
}

@font-face {
    font-family: "DejaVu Sans";
    font-weight: bold;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Bold.ttf") format("truetype");
}

@font-face {
    font-family: "DejaVu Sans";
    font-style: italic;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
}

@font-face {
    font-family: "DejaVu Sans";
    font-weight: bold;
    font-style: italic;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
}

ul.timeline {
    list-style-type: none;
    position: relative;
}

ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}

ul.timeline>li {
    margin: 20px 0;
    /* padding-left: 20px; */
}

ul.timeline>li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #22c0e8;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}

.opNos-div-content {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #007fff;
    padding-left: 35px;
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.opDesc-div-content {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #36454F;
    padding-left: 30px;
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.opDesc-div-content-print {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #36454F;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
    font-size: 14px;
}

.opDesc-div-content-print-c {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #007fff;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
    font-size: 14px;
}

.woNos-div-content {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #007fff;
    padding-left: 35px;
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.woDesc-div-content {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #36454F;
    padding-left: 35px;
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.assetNo-div-content {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #007fff;
    padding-left: 45px;
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.assetDesc-div-content {
    border-color: #ffffff !important;
    border-width: 0px;
    color: #36454F;
    padding-left: 45px;
    font-style: italic !important;
    font-family: "DejaVu Sans", "Arial", "sans-serif";
}

.font15 {
    font-size: 30px;
    color: black;
    padding: 5px;
}

.left-padding {
    padding-left: 10px !important;
}

.ml25 {
    margin-left: 25px !important;
}

.lp15 {
    padding-left: 15px !important;
}

.display-block-margin-bottom-8 {
    display: inline-block;
    margin-bottom: 8px;
}

.display-block-position-abs {
    display: inline-block;
    position: absolute;
    margin-top: 8px;
}

.display-block-margin-top-8 {
    display: inline-block;
    margin-top: 8px;
    position: absolute;
}

.display-block-margin-bottom-1 {
    display: inline-block;
    margin-bottom: 2px;
}

:host ::ng-deep p-radiobutton {
    vertical-align: middle !important;
}

.tb-change-header-col {
    color: rgb(255, 255, 255) !important;
    font-size: 25px !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: bold !important;
}

.tb-fs {
    font-size: 25px !important;
    color: #000000 !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

}

:host ::ng-deep .p-datatable .p-datatable-thead>tr>th {
    height: 30px !important;
    padding: 0px 10px 0px 10px !important;
    border: 1px solid #c8c8c8 !important;
}

.log-style {
    padding: 0px 0px 0px 10px;
    margin-bottom: 10px !important;
    font-weight: bold !important;
    margin-top: 10px !important;
}


:host ::ng-deep .p-checkbox {
    position: absolute !important;
}`, "",{"version":3,"sources":["webpack://./src/app/print-pdf/print-pdf.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;;;;;;;;;;;;IAYI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,yFAAyF;IACzF,4BAA4B;IAC5B,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,UAAU;AACd;;AAEA;;;;;;IAMI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;;IAGI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf;;;;;;;;;;;;;sBAakB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;;IAEI,yBAAyB;IACzB,kCAAkC;;AAEtC;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;;;;;GAOG;;;AAGH;;;;;;;GAOG;AACH;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;;AAEd;;;;AAIA;;;;;;;;GAQG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA,kCAAkC;AAClC;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;;;;EAKE;;AAEF;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAG9B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI;;;uBAGmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;;;IAGxC,mBAAmB;IACnB,eAAe;CAClB;;AAED;IACI;;;yBAGqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;KAEK;AACL;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;;;IAMI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;;;;IAII,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;IAC7B,eAAe;IACf,qBAAqB;AACzB;;AAEA,6EAA6E;AAC7E;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;IACI,2CAA2C;IAC3C,oCAAoC;IACpC,kCAAkC;AACtC;AACA;IACI,2CAA2C;IAC3C,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;sCAGsC;;AAEtC;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,0GAA0G;AAC9G;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,+GAA+G;AACnH;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kHAAkH;AACtH;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,kHAAkH;AACtH;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,2DAA2D;IAC3D,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,2DAA2D;;AAE/D;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;AAC/B;;;AAGA;IACI,6BAA6B;AACjC","sourcesContent":["* {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n.col-1,\r\n.col-2,\r\n.col-3,\r\n.col-4,\r\n.col-5,\r\n.col-6,\r\n.col-7,\r\n.col-8,\r\n.col-9,\r\n.col-10,\r\n.col-11,\r\n.col-12 {\r\n    float: left;\r\n}\r\n\r\n.tblPermitTemplate {\r\n    width: 98.6%;\r\n}\r\n\r\n.cs-body-pdf {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: absolute;\r\n    background-image: linear-gradient(0deg, rgba(255, 255, 255, .35), rgba(255, 255, 255, 0));\r\n    background-repeat: no-repeat;\r\n    background-size: 100%;\r\n    z-index: -1;\r\n    width: 100%;\r\n    height: 7%;\r\n}\r\n\r\ninput[type=url][_ngcontent-thv-c176],\r\ninput[type=search][_ngcontent-thv-c176],\r\ninput[type=text][_ngcontent-thv-c176],\r\ninput[type=datetime][_ngcontent-thv-c176],\r\ninput[type=date][_ngcontent-thv-c176],\r\ntextarea[_ngcontent-thv-c176] {\r\n    font-size: 14px !important;\r\n}\r\n\r\n.cs-header {\r\n    clear: both;\r\n    width: 100%;\r\n    margin: 0px auto;\r\n}\r\n\r\n.top-left {\r\n    position: absolute;\r\n    top: 40px;\r\n    left: 40px;\r\n    /* z-index: 999; */\r\n}\r\n\r\n.header-details {\r\n    margin: 0px;\r\n    padding: 5px 0px;\r\n    /* color: #000000; */\r\n}\r\n\r\n.header-details h1,\r\n.header-details h5,\r\n.header-details p {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.header-details h1 {\r\n    margin: 0px;\r\n    padding: 10px 15px 10px 0px;\r\n    text-align: center;\r\n    /* font-size: 1.8em; */\r\n    font-weight: 400;\r\n    /* color: #fff; */\r\n}\r\n\r\n.header-details h5 {\r\n    margin: 0px;\r\n    padding: 5px 15px 10px 0px;\r\n    text-align: center;\r\n    font-size: 1em;\r\n    font-weight: 400;\r\n    /* color: #fff; */\r\n}\r\n\r\n.status-overlay-pdf {\r\n    position: absolute;\r\n    right: 46px;\r\n    top: 28px;\r\n    width: 128px;\r\n    height: 33px;\r\n    padding-top: 7px;\r\n    cursor: pointer;\r\n    background-color: #33aaff;\r\n    color: #FFF !important;\r\n    background-position: -496px -229px;\r\n    padding-left: 13px;\r\n    letter-spacing: 0.5px;\r\n    font-size: 14px;\r\n    /* position: absolute;\r\n    right: 20px;\r\n    top: 20px;\r\n    width: 170px;\r\n    height: 45px;\r\n    margin-left: 12px;\r\n    padding-top: 2px;\r\n    cursor: pointer;\r\n    background-color: #33aaff;\r\n    color: #FFF !important;\r\n    background-position: -496px -229px;\r\n    padding-left: 7px;\r\n    letter-spacing: 0.5px;\r\n    font-size: 16px; */\r\n}\r\n\r\ntr:nth-child(even) {\r\n    background-color: whitesmoke;\r\n}\r\n\r\ntr:nth-child(odd) {\r\n    background-color: white;\r\n}\r\n\r\n#qusDiv:nth-child(even) {\r\n    background-color: whitesmoke;\r\n}\r\n\r\n#qusDiv:nth-child(odd) {\r\n    background-color: white;\r\n}\r\n\r\n#tblTypeBody:nth-child(even) {\r\n    background-color: whitesmoke;\r\n}\r\n\r\n#tblTypeBody:nth-child(odd) {\r\n    background-color: rgb(250, 250, 250);\r\n}\r\n\r\n.top-right {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 25px;\r\n    font-size: 25px;\r\n    cursor: pointer;\r\n}\r\n\r\n.watermark {\r\n\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: auto;\r\n    margin-left: 30%;\r\n    position: absolute;\r\n    z-index: 999;\r\n    top: 0;\r\n    bottom: 0;\r\n    text-align: center;\r\n    /* margin: auto; */\r\n    left: 0;\r\n    right: 0;\r\n    width: 150px;\r\n    height: 150px;\r\n    font-weight: bold;\r\n    font-size: 400%;\r\n    color: #504e4e;\r\n    opacity: 0.2;\r\n    transform: rotate(-6deg) scale(1.7, 1.5);\r\n}\r\n\r\n.clsLogo {\r\n    height: 51px;\r\n    width: 180px;\r\n    /* border: 1px solid #1F4E78; */\r\n    padding-right: 5px;\r\n    margin-top: 7px;\r\n}\r\n\r\n.mapImage {\r\n    height: 800px !important;\r\n    width: 100% !important;\r\n}\r\n\r\n.clsLogoHidden {\r\n    height: 45px;\r\n    width: 157px;\r\n    padding-right: 5px;\r\n    padding-top: 10px;\r\n    padding-bottom: -5px;\r\n}\r\n\r\n:host ::ng-deep .ui-inputtext {\r\n    /* width: 250px !important; */\r\n    margin: 0;\r\n    outline: medium none;\r\n    padding: .25em;\r\n    font-weight: normal;\r\n}\r\n\r\n:host ::ng-deep input[type=text] {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n.clsHeader {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    margin-left: -20px;\r\n}\r\n\r\n.clsHeaderWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n    /* margin-left: -6px; */\r\n}\r\n\r\n:host ::ng-deep input[disabled] {\r\n    color: #848484 !important;\r\n    background-color: white !important;\r\n}\r\n\r\ndisabled {\r\n\r\n    color: #848484 !important;\r\n    background-color: white !important;\r\n\r\n}\r\n\r\n.clsHeaderHiddenChild {\r\n    background-color: White;\r\n    width: 30px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 10px;\r\n}\r\n\r\n/* .clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    margin-left: -20px;\r\n} */\r\n\r\n\r\n/* .clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 40px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n   \r\n} */\r\n.clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    /* padding: 10px; */\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    /* padding: 10px; */\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n    /* margin-left: -6px; */\r\n}\r\n\r\n.left {\r\n\r\n    display: table-cell;\r\n    /* width:6%; */\r\n\r\n}\r\n\r\n.middle {\r\n\r\n    display: table-cell;\r\n    width: 100%;\r\n}\r\n\r\n.right {\r\n\r\n    display: table-cell;\r\n    width: 10%;\r\n\r\n}\r\n\r\n\r\n\r\n/* .clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n    /* margin-left: -6px; \r\n} */\r\n\r\n/* .tblPermitTemplate td {\r\n    background-color: white;\r\n} */\r\n\r\n/* .tblPermitTemplate tr {\r\n    border: 1px solid #1F4E78;\r\n} */\r\n\r\n.tblPermitTemplate tr th {\r\n    /* background-color: #1F4E78; */\r\n    color: white;\r\n}\r\n\r\n/* ,td .tblPermitTemplate tr th  */\r\n.tblPermitTemplate tr {\r\n    padding: 6px;\r\n}\r\n\r\n.clsValue {\r\n    color: black;\r\n    /* font-weight: bold; */\r\n    margin-left: 5px;\r\n}\r\n\r\n.clsTextArea {\r\n    color: black;\r\n    border: 1px solid #1F4E78;\r\n    resize: none;\r\n}\r\n\r\n.clsTable {\r\n    margin: 5px 5px 0px 0px;\r\n    /* width: 100%; */\r\n}\r\n\r\n.clsTable td {\r\n    /* border: 3px solid white !important; */\r\n    border: 1px solid lightgray !important;\r\n}\r\n\r\n.clsTable th {\r\n    border: 1px solid black;\r\n}\r\n\r\n.clsTablesContainer {\r\n    overflow: auto;\r\n    /* height: 425px; */\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.clsBgWhite {\r\n    background-color: white;\r\n    /* margin-bottom: 10px; */\r\n}\r\n\r\n.clsHeaderParent {\r\n    width: 98.5%;\r\n    padding-left: 30px;\r\n    background-color: White;\r\n}\r\n\r\n#pnlPreviewTemp {\r\n    /* background-color: white; */\r\n    position: relative;\r\n    padding-left: 30px;\r\n    /* padding-right: 30px; */\r\n    font-size: 30px !important;\r\n}\r\n\r\n/* .clsMarginBottom {\r\n    margin-top: 15px !important;\r\n    line-height: 30px;\r\n    border-collapse: separate;\r\n    border-spacing: 0 2em; \r\n}*/\r\n\r\n.clsCheckboxContainer {\r\n    padding: 5px;\r\n    color: black;\r\n    /* font-size: 30px; */\r\n}\r\n\r\n.clsCheckBox {\r\n    height: 80px;\r\n    overflow: auto;\r\n}\r\n\r\n.clsCheckboxDownContainer {\r\n    padding: 5px;\r\n    color: black;\r\n    font-size: 30px;\r\n    word-break: break-all;\r\n}\r\n\r\n.btn-primary {\r\n    margin-right: 5px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788 !important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4 !important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header {\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;\r\n}\r\n\r\n.approveMessage {\r\n    color: #ff3232;\r\n    font-weight: normal;\r\n}\r\n\r\n/* .permitTypeImages {\r\n    height: 68px;\r\n    width: 88%;\r\n} */\r\n\r\n.permitTypeImages {\r\n    /* max-height: 88px;\r\n    height: 100%;\r\n     width: 100%;\r\n     min-width: 88px; */\r\n    width: 70px;\r\n    height: 71px;\r\n}\r\n\r\n.disabled {\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\n:host ::ng-deep .p-dialog-mask {\r\n    z-index: auto !important;\r\n    position: relative;\r\n}\r\n\r\n:host ::ng-deep .ui-chkbox-label {\r\n    font-size: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-radiobutton-label {\r\n    font-size: 30px !important;\r\n}\r\n\r\n.clsShift {\r\n    left: -3px !important;\r\n}\r\n\r\n::ng-deep label {    \r\n    /* Add your custom css property value. */    \r\n    \r\n   \r\n    font-weight: normal;\r\n    margin-top: 5px;\r\n }\r\n\r\n.vrtAlignLbl {\r\n    /* padding: 0px 0px 0px 0px;\r\n    font: 13px !important;\r\n    top: 5px! important;\r\n    position: relative; */\r\n    padding-left: 15px !important;\r\n}\r\n\r\n.indentTable {\r\n    position: relative;\r\n    left: 15px !important;\r\n    padding-right: 10px;\r\n}\r\n\r\n.row-align {\r\n    padding: 5px 5px 5px 5px !important;\r\n}\r\n\r\n/* :host ::ng-deep body .ui-chkbox .ui-chkbox-box .ui-chkbox-icon {\r\n    font-size: 20px !important;\r\n  } */\r\n:host ::ng-deep .ui-chkbox .ui-chkbox-box {\r\n    border: 1px solid #000000 !important;\r\n}\r\n\r\n:host ::ng-deep .ui-radiobutton .ui-radiobutton-box {\r\n    border: 1px solid #000000 !important;\r\n}\r\n\r\n:host ::ng-deep body .ui-radiobutton-label {\r\n    font-size: 30px !important;\r\n}\r\n\r\n:host ::ng-deep body .ui-chkbox-label {\r\n    font-size: 30px !important;\r\n}\r\n\r\nspan {\r\n    color: #000000 !important;\r\n}\r\n\r\n.clsTablesContainer td {\r\n    border-color: Gray !important;\r\n}\r\n\r\ninput[type=url],\r\ninput[type=search],\r\ninput[type=text],\r\ninput[type=datetime],\r\ninput[type=date],\r\ntextarea {\r\n    font-size: 30px !important;\r\n}\r\n\r\n.text-style {\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.clsInnerHtml,\r\n.clsInnerHtml *,\r\n.clsInnerHtml p,\r\n.clsInnerHtml span {\r\n    display: block !important;\r\n    white-space: normal !important;\r\n    overflow-wrap: break-word !important;\r\n    word-break: normal !important;\r\n    max-width: 100%;\r\n    width: 96% !important;\r\n}\r\n\r\n/* Text element width class for textbox, textarea, label, paragraph content */\r\n.clsTextElementWidth {\r\n    width: 98% !important;\r\n    padding-left: 15px;\r\n}\r\n\r\n.blank-height {\r\n    min-height: 35px !important;\r\n    display: inline-block !important;\r\n}\r\n\r\n.list-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-gap: 10px;\r\n    background-color: #eeee e;\r\n    padding: 5px;\r\n    color: black;\r\n}\r\n\r\n/* .clsBorder{\r\n    border: 1px solid lightgrey !important;\r\n} */\r\n\r\n/* :host ::ng-deep .clsInnerHtml > p > span{\r\n    margin-left: 8px !important;\r\n    float: left !important;\r\n} */\r\n\r\n.left-margin {\r\n    /* padding: 15px 0px 0px 10px !important; */\r\n    padding: 0px 0px 0px 10px !important;\r\n    /* padding: 5px 10px !important; */\r\n}\r\n.left-margin-para {\r\n    /* padding: 15px 0px 0px 10px !important; */\r\n    padding: 0px 0px 0px 20px !important;\r\n    /* padding: 5px 10px !important; */\r\n}\r\n\r\n.paragraph-margin {\r\n    padding: 0px 0px 7px 0px !important;\r\n}\r\n\r\n.upload-margin {\r\n    padding-top: 10px !important;\r\n}\r\n\r\n/* table { page-break-inside:auto }\r\ndiv   { page-break-inside:avoid; } \r\nthead { display:table-header-group }\r\ntfoot { display:table-footer-group } */\r\n\r\n.asset-div {\r\n    background-color: #f2faff !important;\r\n    border: 1px solid #ede9d8;\r\n}\r\n\r\n.wo-div {\r\n    background-color: #ffffff !important;\r\n    border: 1px solid #ede9d8;\r\n    margin: 10px;\r\n    padding: 5px;\r\n}\r\n\r\n/* border: 1px solid #ede9d8; */\r\n.op-div {\r\n    background-color: #ffffff !important;\r\n    margin: 5px;\r\n    padding: 3px;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-weight: bold;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Bold.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-style: italic;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-weight: bold;\r\n    font-style: italic;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\r\n}\r\n\r\nul.timeline {\r\n    list-style-type: none;\r\n    position: relative;\r\n}\r\n\r\nul.timeline:before {\r\n    content: ' ';\r\n    background: #d4d9df;\r\n    display: inline-block;\r\n    position: absolute;\r\n    left: 29px;\r\n    width: 2px;\r\n    height: 100%;\r\n    z-index: 400;\r\n}\r\n\r\nul.timeline>li {\r\n    margin: 20px 0;\r\n    /* padding-left: 20px; */\r\n}\r\n\r\nul.timeline>li:before {\r\n    content: ' ';\r\n    background: white;\r\n    display: inline-block;\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    border: 3px solid #22c0e8;\r\n    left: 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    z-index: 400;\r\n}\r\n\r\n.opNos-div-content {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #007fff;\r\n    padding-left: 35px;\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.opDesc-div-content {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #36454F;\r\n    padding-left: 30px;\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.opDesc-div-content-print {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #36454F;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n    font-size: 14px;\r\n}\r\n\r\n.opDesc-div-content-print-c {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #007fff;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n    font-size: 14px;\r\n}\r\n\r\n.woNos-div-content {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #007fff;\r\n    padding-left: 35px;\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.woDesc-div-content {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #36454F;\r\n    padding-left: 35px;\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.assetNo-div-content {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #007fff;\r\n    padding-left: 45px;\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.assetDesc-div-content {\r\n    border-color: #ffffff !important;\r\n    border-width: 0px;\r\n    color: #36454F;\r\n    padding-left: 45px;\r\n    font-style: italic !important;\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n}\r\n\r\n.font15 {\r\n    font-size: 30px;\r\n    color: black;\r\n    padding: 5px;\r\n}\r\n\r\n.left-padding {\r\n    padding-left: 10px !important;\r\n}\r\n\r\n.ml25 {\r\n    margin-left: 25px !important;\r\n}\r\n\r\n.lp15 {\r\n    padding-left: 15px !important;\r\n}\r\n\r\n.display-block-margin-bottom-8 {\r\n    display: inline-block;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.display-block-position-abs {\r\n    display: inline-block;\r\n    position: absolute;\r\n    margin-top: 8px;\r\n}\r\n\r\n.display-block-margin-top-8 {\r\n    display: inline-block;\r\n    margin-top: 8px;\r\n    position: absolute;\r\n}\r\n\r\n.display-block-margin-bottom-1 {\r\n    display: inline-block;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n:host ::ng-deep p-radiobutton {\r\n    vertical-align: middle !important;\r\n}\r\n\r\n.tb-change-header-col {\r\n    color: rgb(255, 255, 255) !important;\r\n    font-size: 25px !important;\r\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n    font-weight: bold !important;\r\n}\r\n\r\n.tb-fs {\r\n    font-size: 25px !important;\r\n    color: #000000 !important;\r\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-thead>tr>th {\r\n    height: 30px !important;\r\n    padding: 0px 10px 0px 10px !important;\r\n    border: 1px solid #c8c8c8 !important;\r\n}\r\n\r\n.log-style {\r\n    padding: 0px 0px 0px 10px;\r\n    margin-bottom: 10px !important;\r\n    font-weight: bold !important;\r\n    margin-top: 10px !important;\r\n}\r\n\r\n\r\n:host ::ng-deep .p-checkbox {\r\n    position: absolute !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
